import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HabitacionService } from '@core/service/habitacion.service';
import { of, Subject, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { flatMap } from 'rxjs/operators';
import * as moment from 'moment';
import { SharedComponentInterface } from '@core/class/sharedComponent.interface';
import { RegistroService } from '@app/core/service/registro.service';

@Component({
  selector: 'app-tarifa-forms',
  templateUrl: './tarifa-forms.component.html',
  styles: []
})
export class TarifaFormsComponent
  implements AfterViewInit, OnInit, SharedComponentInterface {
  formGroup: FormGroup;
  @Input() habitacionId: any; // habitacion id
  @Input() idRegistro: any; // habitacion id
  @Output() formReady = new EventEmitter<any>();

  @Input() subjectShared: Subject<{
    tipo: string;
    total: number;
    precio?: number;
  }>;
  // subscription = this.subjectShared.asObservable();

  habitacion: any;
  estadoTarifa: string;
  newDateString: string;
  private routersubscriber: Subscription;
  textDateTime: string;
  nextDateText: string;
  newDate = moment();
  private tarifaSelect: any;

  count = 0;

  constructor(
    private formBuilder: FormBuilder,
    private habitacionService: HabitacionService,
    private route: ActivatedRoute,
    public registroService: RegistroService,
    private router: Router
  ) {
    // 2021-04-03T09:34
    this.newDateString = this.newDate.format('YYYY-MM-DDTHH:mm');
    // console.log(this.newDateString);

    this.formGroup = this.formBuilder.group({
      fecha_inicio: [this.newDateString],
      fecha_fin: ['', Validators.required],
      fecha_aux: '', // fecha fin del back
      hora_inicio: '',
      hora_fin: '',
      tarifa: '',
      tarifa_id: '',
      precio: ''
    });

    this.formGroup.controls.precio.valueChanges.subscribe((res: any) => {
      this.calDate();
    });

    // this.formGroup.controls.tarifa_id.valueChanges.subscribe((res: any) => {
    //   // debugger;
    //   console.log(res);
    //   // this.calDate();
    //   // if(this.habitacion){
    //     this.habitacion.tipo_habitacion.tarifas.forEach((data: any) => {
    //       if(data.tarifa_id === Number(res)){
    //         this.estadoTarifa = data.unidad;
    //         if (data.unidad === 'Día') {
    //           this.tarifaSelect = data;
    //           console.log('cambiando', data);
    //           // this.formGroup.patchValue({ tarifa_id: res.tarifa_id });
    //           this.formGroup.patchValue({ precio: data.precio });
    //           // this.subjectShared.next({ tipo: 'hora', total: 0, precio: 0 });
    //           this.calDate();
    //         }
    //         if (data.unidad === 'Hora') {
    //           this.changeHora(data.precio);
    //         }
    //       }
    //     })
    //   // }

    //   this.list();
    // })

    // this.subscription.subscribe(res => {
    //   console.log('tarifa', res);
    // });
  }

  ngAfterViewInit(): void {
    this.subjectShared.subscribe(res => {
      console.log('tarifas', res);
    });

    // this.list();
  }

  ngOnInit(): void {
    this.habitacionService.getById(this.habitacionId).subscribe(res => {
      // debugger;
      this.habitacion = res;

      this.formGroup.patchValue({
        tarifa_id: res.tipo_habitacion.tarifas[0].tarifa_id,
        tarifa: res.tipo_habitacion.tarifas[0].unidad,
        precio: res.tipo_habitacion.tarifas[0].precio
      });
      this.changeTarifa(res.tipo_habitacion.tarifas[0].tarifa_id);
    });
    this.onValueChange();

    this.routersubscriber = this.route.queryParams
      .pipe(
        flatMap(query => {
          console.log('query', query);
          if (Object.keys(query).length === 0) {
            return of();
          } else {
            this.formGroup.patchValue(query);
            return this.habitacionService.listado(query);
          }
        })
      )
      .subscribe(res => {
        console.log('tarifa', res);
      });
  }

  list() {
    if (this.count === 0) {
      this.count = 1;
      if (this.idRegistro) {
        this.registroService.getById(this.idRegistro).subscribe(ress => {
          this.formGroup.patchValue({
            tarifa_id: ress.tarifa.tarifa_id,
            tarifa: ress.tarifa.unidad,
            precio: ress.precio,
            fecha_inicio: moment(ress.fecha_inicio).format('YYYY-MM-DDTHH:mm'),
            fecha_fin: moment(ress.fecha_fin).format('YYYY-MM-DD')
          });
        });
      }
    }
  }

  changeTarifa(tarifa_id: any) {
    this.habitacion.tipo_habitacion.tarifas.forEach((data: any) => {
      if (data.tarifa_id === Number(tarifa_id)) {
        this.estadoTarifa = data.unidad;
        if (data.unidad === 'Día') {
          this.tarifaSelect = data;
          console.log('cambiando', data);
          // this.formGroup.patchValue({ tarifa_id: res.tarifa_id });
          this.formGroup.patchValue({ precio: data.precio });
          // this.subjectShared.next({ tipo: 'hora', total: 0, precio: 0 });
          this.calDate();
        }
        if (data.unidad === 'Hora') {
          this.changeHora(data.precio);
        }
      }
    });

    // this.estadoTarifa = unidad;
    // this.habitacion.tipo_habitacion.tarifas.forEach((res: any) => {
    //   if (res.unidad === unidad) {
    //     this.tarifaSelect = res;
    //     console.log('cambiando', res);
    //     this.formGroup.patchValue({ tarifa_id: res.tarifa_id });
    //     this.formGroup.patchValue({ precio: res.precio });
    //     // this.subjectShared.next({ tipo: 'hora', total: 0, precio: 0 });
    //     this.calDate();
    //   }
    //   if (unidad === 'Hora') {
    //     this.changeHora(res.precio);
    //   }
    // });
  }

  changeFechaInicio() {
    this.calDate();
  }

  onValueChange(event?: any) {
    // debugger;
    // console.log(event?.currentTarget?.id);
    console.log(event);
    console.log('forms value tarifa', this.formGroup.value);
    this.formReady.emit({ name: 'tarifas', form: this.formGroup });
  }

  change(value: any) {
    console.log(value);
    // debugger;
    const fecha = moment(value);
    const dateAdd12 = fecha.add(12, 'hours');
    const datefinstr = dateAdd12.format('YYYY-MM-DDTHH:mm');
    const datefortmat = dateAdd12.format(
      '[Hasta: ] DD-MM-YYYY [ hora: ] HH:mm a '
    );
    console.log(datefinstr);
    this.textDateTime = datefortmat;
    // console.log(fecha);
    this.formGroup.patchValue({ fecha_fin: datefinstr });

    // this.formGroup.get('fecha_inicio').value;

    console.log(this.formGroup.get('fecha_inicio').value);
    const fechaInicio = moment(this.formGroup.get('fecha_inicio').value);
    // const diffDate = moment(this.formGroup.get('fecha_inicio').value).diff(
    //   dateAdd12,
    //   'days'
    // );
    // let diffDate = dateAdd12.diff(
    let diffDate = moment(datefinstr).diff(fechaInicio, 'days');
    // debugger;
    // console.log('hora', fechaInicio.format('HH:mm'));
    // if (this.estadoTarifa === 'Hora') {
    //   this.changeHora();
    //   return;
    // }
    console.log('asdasd f f d s d s d sd ' + Number(fechaInicio.format('HH')));
    if (Number(fechaInicio.format('HH')) < 6) {
      diffDate++;
    }

    if (Number(fechaInicio.format('HH')) >= 12) {
      diffDate++;
    }

    // todo aqui hacer cambios para las horas especiales
    if (diffDate === 0) {
      // console.log(1);
      // this.getDays.emit('1');
      this.subjectShared.next({
        tipo: 'dia',
        total: 1,
        // total: diffDate,
        // precio: this.tarifaSelect.precio
        precio: this.formGroup.controls.precio.value
      });
      return;
    }

    /*  else if (fechaInicio.format('HH:mm') === '05:00') {

        return;
      } else if (fechaInicio.format('HH:mm') === '06:00') {

        return;
      }*/
    // this.subjectShared.next({ diffDate * -1 });
    this.subjectShared.next({
      tipo: 'dia',
      total: diffDate,
      precio: this.formGroup.controls.precio.value
    });

    // this.getDays.emit(diffDate);
  }

  private changeHora(precio: number) {
    this.subjectShared.next({
      tipo: 'hora',
      total: 1,
      // precio: precio ? precio : this.tarifaSelect.precio
      precio: precio ? precio : this.formGroup.controls.precio.value
    });
  }

  private calDate() {
    // debugger;
    const fecha = moment(this.formGroup.get('fecha_inicio').value);
    const hora = fecha.format('HH:mm:ss').split(':');

    if (Number(hora[0]) < 6) {
      this.nextDateText = fecha.format('YYYY-MM-DD');
      this.formGroup.get('fecha_aux').patchValue(this.nextDateText);
    } else {
      this.nextDateText = fecha.add('days', 1).format('YYYY-MM-DD');
      this.formGroup.get('fecha_aux').patchValue(this.nextDateText);
    }

    this.change(this.nextDateText);
  }
}
